// Angular owns registration; this coordinator owns update checks and reloads.
export function watchAppUpdates(enabled: boolean): void {
  if (!enabled || !('serviceWorker' in navigator)) return;
  const workers = navigator.serviceWorker;
  let controller = workers.controller;
  let reloading = false;
  let checking = false;
  let lastCheck = 0;

  workers.addEventListener('controllerchange', () => {
    const previous = controller;
    controller = workers.controller;
    // First install must not interrupt the page. A replacement must be active
    // and controlling this document before we reload, exactly once.
    if (!previous || !controller || controller === previous || reloading) return;
    reloading = true;
    window.location.reload();
  });

  const check = async () => {
    if (checking || document.visibilityState === 'hidden' || Date.now() - lastCheck < 60000) return;
    checking = true;
    lastCheck = Date.now();
    try {
      const registration = await workers.getRegistration('/');
      if (registration) {
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
        await registration.update();
      }
    } catch {
      // Being offline must not prevent using the already loaded app.
    } finally { checking = false; }
  };

  void workers.ready.then(() => check()).catch(() => {});
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void check(); });
  window.addEventListener('pageshow', () => { void check(); });
  window.addEventListener('online', () => { lastCheck = 0; void check(); });
}
